import { NavArrowRight } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconNavArrowRight12Line = createIcon(NavArrowRight, 12, "Line");
export const IconNavArrowRight16Line = createIcon(NavArrowRight, 16, "Line");
export const IconNavArrowRight20Line = createIcon(NavArrowRight, 20, "Line");
export const IconNavArrowRight24Line = createIcon(NavArrowRight, 24, "Line");
export const IconNavArrowRight32Line = createIcon(NavArrowRight, 32, "Line");
export const IconNavArrowRight48Line = createIcon(NavArrowRight, 48, "Line");
export const IconNavArrowRight64Line = createIcon(NavArrowRight, 64, "Line");
